import { render } from "./OilPriceLogPlantsList.vue?vue&type=template&id=71049a8c&scoped=true&ts=true"
import script from "./OilPriceLogPlantsList.vue?vue&type=script&lang=ts"
export * from "./OilPriceLogPlantsList.vue?vue&type=script&lang=ts"

import "./OilPriceLogPlantsList.vue?vue&type=style&index=0&id=71049a8c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71049a8c"]])

export default __exports__